import { loadEnv } from '../../shims/load-env';

export const DEEPSEEK_API_KEY_ENV_VARIABLE_NAME = 'DEEPSEEK_API_KEY';
export const DEEPSEEK_BASE_URL_ENV_VARIABLE_NAME = 'DEEPSEEK_BASE_URL';
export const DEEPSEEK_DEFAULT_MODEL_ENV_VARIABLE_NAME =
  'DEEPSEEK_DEFAULT_MODEL';

export const DEFAULT_DEEPSEEK_BASE_URL = 'https://api.deepseek.com/anthropic';
export const DEFAULT_DEEPSEEK_MODEL = 'deepseek-v4-flash';

let _defaultDeepSeekKey: string | undefined;

export function setDefaultDeepSeekKey(key: string) {
  _defaultDeepSeekKey = key;
}

export function getDefaultDeepSeekKey(): string | undefined {
  return _defaultDeepSeekKey ?? loadEnv()[DEEPSEEK_API_KEY_ENV_VARIABLE_NAME];
}

export function getDefaultDeepSeekBaseURL(): string {
  return (
    loadEnv()[DEEPSEEK_BASE_URL_ENV_VARIABLE_NAME] ?? DEFAULT_DEEPSEEK_BASE_URL
  );
}

export function getDefaultDeepSeekModel(): string {
  return (
    loadEnv()[DEEPSEEK_DEFAULT_MODEL_ENV_VARIABLE_NAME]?.toLowerCase() ??
    DEFAULT_DEEPSEEK_MODEL
  );
}
